const React = require("react");
const T = React.PropTypes;

const FileUploadActionCreators = require("../actionCreators/FileUploadActionCreators.js");
const FileTypeActionCreators = require("../actionCreators/FileTypeActionCreators.js");

const File = require("../types/File.js");
const FileType = require("../types/FileType.js");
const MetadataSpec = require("../types/MetadataSpec.js");

const SelectedFileList = require("./SelectedFileList.jsx");
const SelectedFileProgressList = require("./SelectedFileProgressList.jsx");
const ReviewForm = require("./ReviewForm.jsx");
const MetadataBox = require("./MetadataBox.jsx");

const styles = {
    Message: {
        marginTop: 20,
        color: "#555"
    },
    Footer: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0
    }
};

const SubmitFiles = React.createClass({
    propTypes: {
        style: T.object,
        DisplayOffsetTop: T.number,
        SelectedFileType: FileType.Type.isRequired,
        SelectedFiles: T.arrayOf(File.Type),
        Upload: T.shape({
            IsWorking: T.bool,
            Error: T.object
        }),
        ValidExtensions: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(T.string),
            LoadError: T.object
        }),
        Metadata: T.shape({
            CurrentSpec: MetadataSpec.Type
        })
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        let children = null;
        
        const dropAreaStyle = {
            paddingBottom: 350
        };

        const lockReviewForm = this.props.Upload.IsWorking;

        const firstInvalid = this.props.SelectedFiles.find((f) => f.IsInvalid);
        const hasInvalids = typeof (firstInvalid) !== "undefined";
        
        const requiresMetadata = this.IsMetadataRequired();

        const metadataIsOkay =
            !requiresMetadata
            || (requiresMetadata && this.props.Metadata.CurrentSpec.Data.IsComplete);
            
        const result = (<article style={this.props.style}>
            <div>
                {requiresMetadata
                && (<MetadataBox Spec={this.props.Metadata.CurrentSpec} IsLocked={this.props.Upload.IsWorking} />)}
                {!(this.props.Upload.IsWorking || this.props.Upload.HasErrors)
                && (<SelectedFileList style={dropAreaStyle}
                                      Files={this.props.SelectedFiles}
                                      ValidExtensions={this.props.ValidExtensions} />)}
                {(this.props.Upload.IsWorking || this.props.Upload.HasErrors)
                && (<SelectedFileProgressList style={dropAreaStyle}
                                      Files={this.props.SelectedFiles} />)}
                <ReviewForm style={styles.Footer}
                            FileType={this.props.SelectedFileType}
                            FileCount={this.props.SelectedFiles.length}
                            HasInvalids={hasInvalids}
                            OnSubmit={this.SubmitFiles}
                            OnCancel={this.Cancel}
                            Lock={lockReviewForm}
                            MetadataIsOkay={metadataIsOkay} />
            </div>
        </article>);

        return result;
    },
    SubmitFiles() {
        var metadata = null;

        if (this.IsMetadataRequired()) {
            metadata = this.props.Metadata.CurrentSpec.Data.Arg;
        }

        FileUploadActionCreators.UploadMany(
            this.props.SelectedFileType,
            this.props.SelectedFiles,
            metadata);
    },
    Cancel() {
        FileTypeActionCreators.DeSelect();
    },
    IsMetadataRequired() {
        return (typeof (this.props.Metadata.CurrentSpec) !== "undefined"
            && this.props.Metadata.CurrentSpec.hasOwnProperty("Data"));
    }
});

module.exports = SubmitFiles;


// WEBPACK FOOTER //
// ./src/components/SubmitFiles.jsx